module.exports = __webpack_public_path__ + "media/src/application/media/midural-36eb99a3b95cddecd3a8cbdcb6df7ed6.png";